import { render, staticRenderFns } from "./TransactionEdit.vue?vue&type=template&id=01af8314"
import script from "../../controllers/transaction/transaction-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/transaction/transaction-edit.js?vue&type=script&lang=js&external"
import style0 from "./TransactionEdit.vue?vue&type=style&index=0&id=01af8314&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports